// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__yVJmr","footer":"ModalError_footer__qah2H"};